import { useState } from 'react';

const useToggleSections = (initialState) => {
    const [sections, setSections] = useState(initialState);

    const toggleSection = (section) => {
        setSections(prevSections => ({
            ...prevSections,
            [section]: !prevSections[section]
        }));
    };

    return [sections, toggleSection];
};

export default useToggleSections;
